import React,{useState,useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import {showData} from '../../Utils/APIs/commonShowAPI'
import axios from 'axios';
import { getCookie } from '../../Utils/cookies';
import { externalDataFetch } from '../../Utils/APIs/externalDataFetchAPI';


const Index = ({_id, setComplaintId}) => {
  const Navigate = useNavigate();
  const employeeData = getCookie('empData') ? JSON.parse(getCookie('empData')) : {};


  const [ rejectReasonList, setRejectReasonList ] = useState([]);
  const [complaintData, setComplaintData] = useState({});
  const [ statusList, setStatusList ] = useState([]);
  const [ errorListOnSaveStatus, setErrorListOnSaveStatus ] = useState({});
  const [verify, setVerify] = useState("");
  const [callingVerifyRemark ,setCallingVerifyRemark] = useState("");
  const [ remarkFromList, setRemarkFromList ] = useState('');
  const [externalServicePerson, setExternalServicePerson] = useState([]);
  const [ updateBtnClicked, setUpdateBtnClicked ] = useState(false);
    useEffect(() => {
        showData(`farmer/showComplaint?complaintId=${_id}`,setComplaintData).then((status) => {
          if(status){
            externalDataFetch(`http://88.222.214.93:5000/service-team/find-service-person?id=${status[0].assignEmployee}`,setExternalServicePerson);
            setUpdateBtnClicked(false);
          }
        });
    }, [updateBtnClicked, _id]);

    useEffect(() => {
      let stage = 1;
      if(employeeData.role === "Verify Team-2"){
        stage = 2;
      }
      const fetchData = async() => {
        try {
            const sendRequest = await axios.get(`${process.env.REACT_APP_API_URL}/calling/showStageForVT${stage}`);
            const sendRequest2 = await axios.get(`${process.env.REACT_APP_API_URL}/common/showErrorList`);
            setRejectReasonList(sendRequest2.data.data);
            setStatusList(sendRequest.data.stages);
        } catch (error) {
          console.log('Something went wrong');
        }
      }
      fetchData();
    }, [employeeData]);
    const updateComplaint = async(e) => {
      e.preventDefault();
      console.log({
        complaintId: complaintData[0]._id,
        stageId: verify,
        remark: (remarkFromList === "Others" || remarkFromList === '') ? callingVerifyRemark : remarkFromList
      })
      // continue work 
      try {
        const sendRequest = await axios.post(`${process.env.REACT_APP_API_URL}/calling/verifyComplaint`, {
          complaintId: complaintData[0]._id,
          stageId: verify,
          remark: (remarkFromList === "Others" || remarkFromList === '') ? callingVerifyRemark : remarkFromList
        });
        console.log(sendRequest.data);
        alert('Updated Successfully');
        Navigate('/complaintList');
        setErrorListOnSaveStatus({ status: true, msg: 'Updated Successfully'});
      } catch (error) {
        console.log('Something went wrong');
        setErrorListOnSaveStatus({ status: false, msg: 'Something went wrong'});
      }
    }
    // for image show in full screen
    const [isOpen, setIsOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
  
    const handleImageClick = (imageSrc) => {
      setSelectedImage(imageSrc);
      setIsOpen(true);
    };
  
    const handleCloseModal = () => {
      setIsOpen(false);
    };

    //return Quantity 
    const [showReturnQuantity, setShowReturnQuantity] = useState([]);
    const fetchReturnQuantity = async (contact,contact2) => {
      try {

        const response = await axios.get(`http://88.222.214.93:5000/service-team/incoming-items-data?contact=${contact}&contact2=${contact2}`);
        setShowReturnQuantity(response?.data?.data);
      } catch (error) {
        console.error("Error fetching return quantity:", error);
      }
    };
    let imageArray = [];
    complaintData?.[0]?.RMUData?.forEach(rmu => {
      [
      rmu?.simPhoto?.[0],
      rmu?.finalFoundation?.[0],
      rmu?.panelPhoto?.[0],
      rmu?.photoWithWater?.[0],
      rmu?.photoWithController?.[0]
      ].filter(Boolean).forEach(photo => imageArray.push(photo));
    });
    const updated_data = imageArray.map(photo =>
      photo.replace("http://88.222.214.93:8001", "https://service.galosolar.com/api")
    );
    useEffect(()=>{
      fetchReturnQuantity(complaintData?.[0]?.Farmer[0]?.contact,complaintData?.[0]?.contact)
    },[complaintData])
  return (
    (complaintData !==undefined) ? 
    <>
      <div className=" flex flex-col">
        <div>
          <h1 className=' text-3xl font-semibold tracking-widest text-center p-2 bg-gray-900 text-gray-100'>C<span className='text-lg'>OMPLAINT</span> D<span className='text-lg'>ETAILS</span></h1>
        </div>
        <div className="flex flex-row justify-around bg-gray-200 ">
          <h1 className=' text-2xl font-semibold  tracking-widest p-2'>F<span className='text-lg'>armer</span> N<span className='text-lg'>ame - {complaintData[0]?.Farmer[0]?.farmerName}</span></h1>
          <h1 className=' text-2xl font-semibold  tracking-widest p-2'>S<span className='text-lg'>aral</span> I<span className='text-lg'>d - {complaintData[0]?.Farmer[0]?.saralId}</span></h1>
        </div>
        <div className=" flex flex-row justify-around p-1">
          <div className='mt-3'>
            <table className='text-left'>
              <tr>
                <th>Contact</th>
                <td>: {complaintData[0]?.Farmer[0]?.contact}</td>
              </tr>
              <tr>
                <th>Father Or Husband </th>
                <td>: {complaintData[0]?.Farmer[0]?.fatherOrHusbandName}</td>
              </tr>
              <tr>
                <th>Installation Date </th>
                <td>: {complaintData[0]?.Farmer[0]?.installationDate}</td>
              </tr>
              <tr>
                <th>State</th>
                <td>: {complaintData[0]?.Farmer[0]?.state}</td>
              </tr>
              <tr>
                <th>District</th>
                <td>: {complaintData[0]?.Farmer[0]?.district}</td>
              </tr>
              <tr>
                <th> Block </th>
                <td>: {complaintData[0]?.Farmer[0]?.block}</td>
              </tr>
              {/* <tr>
                <th>Gram Panchayat </th>
                <td>: {complaintData[0]?.Farmer[0]?.gram_panchayat || 'N/A'}</td>
              </tr> */}
              <tr>
                <th> Address</th>
                <td>: {complaintData[0]?.Farmer[0]?.address || 'N/A'}</td>
              </tr>
              <tr>
                <th>Village</th>
                <td>: {complaintData[0]?.Farmer[0]?.village}</td>
              </tr>
              <tr>
                <th>Initial Longitude </th>
                <td>: {complaintData[0]?.Farmer[0]?.longitude}</td>
              </tr>
              <tr>
                <th>Initial Latitude </th>
                <td>: {complaintData[0]?.Farmer[0]?.latitude}</td>
              </tr>
              
              <tr>
                <th>Pump Type </th>
                <td>: {complaintData[0]?.Farmer[0]?.pump_type}</td>
              </tr>
              <tr>
                <th>Department </th>
                <td>: {complaintData[0]?.Farmer[0]?.department}</td>
              </tr>
              <tr>
                <th>Product </th>
                <td>: {complaintData[0]?.Farmer[0]?.HP + "HP " + complaintData[0]?.Farmer[0]?.AC_DC}</td>
              </tr>
              
              <tr>
                <th>Visited Longitude </th>
                <td>: {complaintData[0]?.RMUData[0]?.longitude}</td>
              </tr>
              <tr>
                <th>Visited Latitude </th>
                <td>: {complaintData[0]?.RMUData[0]?.latitude}</td>
              </tr>
            </table>
          </div>
          <div className='mt-3'>
          <table className='text-left'>
              <tr>
                <th>Tracking Id</th>
                <td>: {complaintData[0]?.trackingId}</td>
              </tr>
              <tr>
                <th>Complainant Name </th>
                <td>: {complaintData[0]?.complainantName}</td>
              </tr>
              <tr>
                <th> Contact</th>
                <td>: {complaintData[0]?.contact}</td>
              </tr>
              <tr>
                <th>Authority</th>
                <td>: {complaintData[0]?.authority}</td>
              </tr>
              <tr>
                <th>Priority</th>
                <td className={(complaintData[0]?.priority === 'Most Urgent')?'text-red-800':''}>: {complaintData[0]?.priority}</td>
              </tr>
              <tr>
                <th>Company</th>
                <td>: {complaintData[0]?.company}</td>
              </tr>
              <tr>
                <th>Stage</th>
                <td>: {complaintData[0]?.Stage[0]?.stage}</td>
              </tr>
              <tr>
                <th>Assign Employee</th>
                <td>: {externalServicePerson.name || 'Not Assigned'}</td>
              </tr>
              <tr>
                <th>Employee Longitude</th>
                <td>: {externalServicePerson?.longitude || 'Not Available'}</td>
              </tr><tr>
                <th>Employee Latitude</th>
                <td>: {externalServicePerson?.latitude || 'Not Available'}</td>
              </tr>
              <tr>
                <th>Complaint Date</th>
                <td>: {complaintData[0]?.created_At}</td>
              </tr>
              <tr className='my-2'>
                <th>Images</th>
                <td >
                  <div className='flex overflow-auto max-w-[20rem]'>
                    {
                      complaintData[0]?.RMUData.at(-1)?.photos?.map((data)=>(
                        <div className='overflow-hidden relative w-24 h-24 mr-2 mb-2'>
                          <img 
                          src={data} 
                          className='rounded-lg transition-transform duration-300 ease-in-out transform hover:scale-110 w-full h-full object-cover'  
                          alt="Network error"
                          onClick={() => handleImageClick(data)}
                           />

                        </div>
                      ))
                    }
                    {
                      updated_data.length > 0 && updated_data.map((data) =>(
                        <div className='overflow-hidden relative w-24 h-24 mr-2 mb-2'>
                          <img 
                          src={data} 
                          className='rounded-lg transition-transform duration-300 ease-in-out transform hover:scale-110 w-full h-full object-cover'  
                          alt="Network error"
                          onClick={() => handleImageClick(data)}
                           />

                        </div>
                      ))
                    }
                  </div>
                </td>
              </tr>
            </table>
            <div className='bg-gray-200'>
              <h3 className='text-center bg-yellow-300 text-2xl'>C<span className='text-lg'>OMPLAINT</span> D<span className='text-lg'>ETAIL</span></h3>
              <span className='p-2'>{complaintData[0]?.complaintDetails}</span>
            </div>
          </div>
          <div className='w-2/12'>
            {(complaintData?.[0]?.Stage?.[0]?._id === "675be30222ae6f63bf772dd0" || complaintData?.[0]?.Stage?.[0]?._id === "6793729a76b16307616f46c6" || complaintData?.[0]?.Stage?.[0]?._id === "675be30222ae6f63bf772dd1" || complaintData?.[0]?.Stage?.[0]?._id ==="67c824e7d16853e3982439ff") && <form onSubmit={updateComplaint}>
              <>
                <div className='mt-3'>
                  <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900">Farmer Satisfied<span className='text-red-500 fixed h-3'>*</span></label>
                  <select onChange={(e) => { setVerify(e.target.value) }} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 " id="state-select">
                    <option value="">-- Select --</option>
                    {statusList.map(({_id, stage}) => (
                      <option key={_id} value={_id}>{stage}</option>
                    ))}
                  </select>
                  {/* {priorityError && <span className='text-red-500 text-xs ml-2'>Select Priority</span>} */}
                </div>
                {(verify === "676160e4ee8e5f880ec33944" || verify === "676160e4ee8e5f880ec33945") && <div className='mt-3'>
                  <label for="first_name" className="block mb-2 text-sm font-medium text-gray-900 ">Select Reason<span className='text-red-500 fixed h-3'>*</span></label>
                  <select onChange={(e) => { setRemarkFromList(e.target.value) }} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5 " id="state-select">
                    <option value="">-- Select Reason --</option>
                    {rejectReasonList.map(({_id, remark}) => (
                      <option key={_id} value={remark}>{remark}</option>
                    ))}
                  </select>
                </div>}
                {(remarkFromList === "Others" || verify === "675d3477835297882dd66cd1" || verify === "675d3477835297882dd66cd2") && <div>
                  <label for="message" className="block mt-2 mb-2 text-sm font-medium text-gray-900 ">Remark</label>
                  <textarea id="message" value={callingVerifyRemark} onChange={(e) => { setCallingVerifyRemark(e.target.value) }} rows="4" className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 " placeholder="Write your thoughts here..."></textarea>
                </div>}
                <button type="submit" className="text-dark  mt-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center firstBgColor">Save</button>
                <span style={{ color: errorListOnSaveStatus?.status ? 'rgb(0, 200, 0)' : 'red'}}>{errorListOnSaveStatus?.msg}</span>
              </>
            </form>}
          </div>
        </div>
      </div>
      {/* Fullscreen Modal */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="relative">
            <img
              src={selectedImage}
              className="w-96 h-96 object-contain"
              alt="Fullscreen"
            />
            <button onClick={handleCloseModal} type="button" className="absolute -top-3 right-8 bg-red-600 rounded-3xl p-2 inline-flex items-center justify-center text-gray-50 hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
              <span className="sr-only">Close menu</span>
              <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}
      <div className="overflow-x-auto ml-3" >
          <table className=" table-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-3 py-1 border border-gray-300">Item Name</th>
                <th className="px-3 py-1 border border-gray-300">Item Quantity</th>
              </tr>
            </thead>
            <tbody>
            {showReturnQuantity.length > 0 ? (
              showReturnQuantity.map((item, index) => (
              // Iterate through each 'items' array in the current object
              item.items.map((subItem, subIndex) => (
              <tr key={`${index}-${subIndex}`} className="odd:bg-gray-50 even:bg-white">
                <td className="px-3 py-1 border border-gray-300">{subItem.itemName}</td>
                <td className="px-3 py-1 border border-gray-300">{subItem.quantity}</td>
              </tr>
          ))
        ))
      ) : (
        <tr>
          <td colSpan="9" className="text-center px-4 py-2 border border-gray-300">No return items found.</td>
        </tr>
        )}
            </tbody>
          </table>
        </div>
      </> : <div className='h-full flex justify-center items-center '><h6 className='text-4xl '>Not allow to show data  </h6></div>
  )
}

export default Index